<template>

  <mu-row class="reportCard top">
    <mu-col width="100" desktop="60" tablet="60">
      <div class="topArrow"></div>
      <mu-card class="bottom errorBox">
        <mu-card-header
          titleClass="upperReport"
          :title="message"
        ></mu-card-header>
        <mu-list>
          <mu-list-item
            v-for="item, index in splicedReports" :key="'sr-' + index"
            :title="item.firstname + ' ' + item.surname"
            :describeText="item.reason">
            <mu-avatar
              slot="leftAvatar"
              :src="(item.profile_thumb !== null) ?  item.profile_thumb : 'static/avatar.png'"
            ></mu-avatar>
          </mu-list-item>
        </mu-list>
        <mu-card-actions align="right">

          <mu-flat-button
            v-if="report.reasons.length > 1 && limitSize !== Infinity"
            label="View all reasons"
            @click.native="showAllReasons()"></mu-flat-button>

          <mu-flat-button
            v-if="limitSize === Infinity" label="Hide reasons"
            @click.native="hideReasons()"
          ></mu-flat-button>

          <mu-flat-button
            v-if="notReportingPage"
            @click.native="goTo(type)"
            label="Handle report"
          ></mu-flat-button>

        </mu-card-actions>


      </mu-card>
    </mu-col>
  </mu-row>

</template>
<script>
  import ReportingApi from '../../api/Reporting'
  import MuFlatButton from "../../../node_modules/muse-ui/src/flatButton/flatButton.vue";
  import MuCardText from "../../../node_modules/muse-ui/src/card/cardText.vue";
  import MuAvatar from "../../../node_modules/muse-ui/src/avatar/avatar.vue";

  export default {
    components: {
      MuAvatar,
      MuCardText,
      MuFlatButton
    },
    name: 'report',
    props: {
      type: {
        type: String,
        default: 'THREAD_ANSWER'
      },
      typeId: {
        type: Number
      }
    },
    data() {
      return {
        limitSize: 1,
        report: {
          reasons: []
        },
        message: ""
      }
    },
    mounted() {
      let self = this;

      if (self.type === 'THREAD_QUESTION') {
        self.message = "This question has been reported";
      }
      if (self.type === 'THREAD_ANSWER') {
        self.message = "This answer has been reported";
      }
      if (self.type === 'LIFE_REPLY' || self.type === 'LIFE_SUBREPLY') {
        self.message = "This comment has been reported";
      }

      ReportingApi.getReport(self.type, self.typeId)
        .then(function (response) {
          self.report = response.data;
        })
    },
    methods: {
      goTo(type) {
        let self = this;

        let routeName;
        if (type === 'THREAD_QUESTION') {
          routeName = 'QuestionReport'
        }
        if (type === 'THREAD_ANSWER') {
          routeName = 'AnswerReport'
        }
        if (type === 'LIFE_REPLY') {
          routeName = 'LifeReplyReport'
        }
        if (type === 'LIFE_SUBREPLY') {
          routeName = 'LifeSubReplyReport'
        }

        self.$router.push({
          name: routeName,
          params: {
            id: self.typeId
          }
        })
      },
      showAllReasons() {
        let self = this;
        self.limitSize = Infinity;
      },
      hideReasons() {
        let self = this;
        self.limitSize = 1;
      }
    },
    computed: {
      splicedReports() {
        let self = this;
        let reasons = JSON.parse(JSON.stringify(self.report.reasons));
        return reasons.splice(0, self.limitSize);
      },
      notReportingPage() {
        let self = this;
        return self.$route.name !== 'QuestionReport' && self.$route.name !== 'AnswerReport' && self.$route.name !== 'LifeReplyReport' && self.$route.name !== 'LifeSubReplyReport'
      }
    }
  }
</script>
<style lang="less">

  .reportCard {
    .errorBox {
      border: 1px solid #e74c3c;
      border-left: 8px solid #e74c3c;
    }
    .upperReport {
      text-transform: uppercase;
      font-weight: 400;
      color: #e74c3c
    }
    .topArrow {
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;

      border-bottom: 5px solid #e74c3c;
      position: relative;
      left: 50%;
    }
  }

</style>



// WEBPACK FOOTER //
// Report.vue?67846d02